import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import CourseTable from './table/js/courseTable';
import CourseCreate from './create/js/courseCreate';

export default function CoursesManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-student-management">
      <div className="eduss-student-management-content">
        <CourseTable reloadKey={reloadKey} onCreate={() => setShowCreateModal(true)} />
      </div>

      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Course</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <CourseCreate onClose={() => setShowCreateModal(false)} onSubmit={() => { setReloadKey(k => k + 1); setShowCreateModal(false); }} />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
